import { ITranslations } from 'types/common';
import { AdminUsersTableTransFields } from './types';
import en from 'translations/en/adminUsersTable.json';
import pl from 'translations/pl/adminUsersTable.json';
import sl from 'translations/sl/adminUsersTable.json';

export const adminUsersTableTranslations: ITranslations<AdminUsersTableTransFields> = {
  name: 'adminUsersTable',
  en,
  pl,
  sl,
};
